import { render, staticRenderFns } from "./MinionDetailCard.vue?vue&type=template&id=703d2589&scoped=true&"
import script from "./MinionDetailCard.vue?vue&type=script&lang=js&"
export * from "./MinionDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./MinionDetailCard.vue?vue&type=style&index=0&id=703d2589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d2589",
  null
  
)

export default component.exports